import * as React from 'react';

import { requestPost } from '../../../../modules/request';

import { Spinner } from './spinner';

import { fetchUserRole } from '../../utils/userAPIs';

// Wraps admin-only UI so it never renders until the current user is confirmed to
// be staff. Signed-out users have their destination saved before login. Other
// non-staff users and request errors are redirected without saving the protected
// route, so it is not replayed after login.
interface StaffOnlyWrapperProps {
  children: React.ReactNode;
}

export const StaffOnlyWrapper = ({ children }: StaffOnlyWrapperProps) => {
  const [authorized, setAuthorized] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    const redirectToLogin = () => { window.location.href = `${window.postbuildEnv.DEFAULT_URL}/session/new`; };
    const savePostAuthRedirectAndLogin = () => {
      requestPost(
        '/session/set_post_auth_redirect',
        { post_auth_redirect: window.location.href },
        redirectToLogin,
        redirectToLogin
      ).catch(redirectToLogin);
    };

    fetchUserRole()
      .then((data) => {
        if (data && data.role === 'staff') {
          setAuthorized(true);
        } else if (data?.role === null) {
          savePostAuthRedirectAndLogin();
        } else {
          redirectToLogin();
        }
      })
      .catch(redirectToLogin);
  }, []);

  if (!authorized) { return <Spinner />; }

  return children as React.ReactElement;
};
